"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.SubHeading1=exports.SubHeading=exports.DeleteModalContainer=exports.ButtonsContainer=void 0;const DeleteModalContainer=exports.DeleteModalContainer=_styledComponents.default.div`
 min-width: 250px;
  height: content-fit;
  text-align: center;
  max-width: 400px;
  .fressPassText{
    text-align: initial;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 30px;
  }
  .align {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    justify-content: space-between;
  }
  .snsHeading{
    margin-bottom: 19px;
  }
  .close{
    width: 45px;
    height: 18px;
    float: inline-end;
    cursor:pointer;
  }
  .snsText{
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 30px;
  }
`,ButtonsContainer=exports.ButtonsContainer=_styledComponents.default.div`
 display:flex;
 flex-direction: column;
 justify-content:center;
 align-items:center;`,SubHeading=exports.SubHeading=_styledComponents.default.div`
 font-size: 20px;
 text-align: center;
 font-weight: 600;
 font-size: 20px;
 line-height: 26px;
 color: #330A0B;
 align-items:center;
 `,SubHeading1=exports.SubHeading1=_styledComponents.default.div`
 font-size: 20px;
 text-align: center;
 font-weight: 600;
 line-height: 24px;
 color: #330A0B;
 align-items:center;
 padding-left: 48px;
 `;